"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
const user_1 = require("../user");
const RichTextBlocks_1 = __importDefault(require("./RichTextBlocks"));
const formatBytes = (bytes, decimals = 1) => {
    if (!bytes)
        return '0 B';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
class Helpers {
    static isFCMAContentType(contentType) {
        return this.CONTENT_TYPES.FCMA === contentType;
    }
    // FixMe REFACTOR and simplify this method
    static parseContentTopics(topics) {
        try {
            const resultObj = Array.isArray(topics)
                ? topics.reduce((result, topic) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
                    if (!topic.fields) {
                        return result;
                    }
                    if (topic.fields.level === Helpers.TAXONOMY_LEVELS[0]) {
                        if (!result.topics.some(a => a.id === topic.sys.id)) {
                            result.topics.push({
                                id: topic.sys.id,
                                name: topic.fields.name,
                                slug: topic.fields.slug,
                            });
                        }
                    }
                    if (((_a = topic.fields) === null || _a === void 0 ? void 0 : _a.parent) && ((_c = (_b = topic.fields) === null || _b === void 0 ? void 0 : _b.parent) === null || _c === void 0 ? void 0 : _c[0]) && ((_e = (_d = topic.fields) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e[0].fields) &&
                        topic.fields.level === Helpers.TAXONOMY_LEVELS[1]) {
                        if (!result.topics.some(b => { var _a, _b; return b.id === ((_b = (_a = topic.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.topics.push({
                                id: (_g = (_f = topic.fields) === null || _f === void 0 ? void 0 : _f.parent) === null || _g === void 0 ? void 0 : _g[0].sys.id,
                                name: (_j = (_h = topic.fields) === null || _h === void 0 ? void 0 : _h.parent) === null || _j === void 0 ? void 0 : _j[0].fields.name,
                                slug: (_l = (_k = topic.fields) === null || _k === void 0 ? void 0 : _k.parent) === null || _l === void 0 ? void 0 : _l[0].fields.slug,
                            });
                        }
                        if (!result.subtopics.some(c => c.id === topic.sys.id)) {
                            result.subtopics.push({
                                id: topic.sys.id,
                                topicId: (_o = (_m = topic.fields) === null || _m === void 0 ? void 0 : _m.parent) === null || _o === void 0 ? void 0 : _o[0].sys.id,
                                topicSlug: (_q = (_p = topic.fields) === null || _p === void 0 ? void 0 : _p.parent) === null || _q === void 0 ? void 0 : _q[0].fields.slug,
                                name: topic.fields.name,
                                slug: topic.fields.slug,
                            });
                        }
                    }
                    if (((_r = topic.fields) === null || _r === void 0 ? void 0 : _r.parent) && ((_t = (_s = topic.fields) === null || _s === void 0 ? void 0 : _s.parent) === null || _t === void 0 ? void 0 : _t[0]) && ((_v = (_u = topic.fields) === null || _u === void 0 ? void 0 : _u.parent) === null || _v === void 0 ? void 0 : _v[0].fields) && ((_y = (_x = (_w = topic.fields) === null || _w === void 0 ? void 0 : _w.parent) === null || _x === void 0 ? void 0 : _x[0].fields) === null || _y === void 0 ? void 0 : _y.parent) && ((_2 = (_1 = (_0 = (_z = topic.fields) === null || _z === void 0 ? void 0 : _z.parent) === null || _0 === void 0 ? void 0 : _0[0].fields) === null || _1 === void 0 ? void 0 : _1.parent) === null || _2 === void 0 ? void 0 : _2[0]) &&
                        topic.fields.level === Helpers.TAXONOMY_LEVELS[2]) {
                        if (!result.topics.some(d => { var _a, _b, _c, _d; return d.id === ((_d = (_c = (_b = (_a = topic.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].fields) === null || _c === void 0 ? void 0 : _c.parent) === null || _d === void 0 ? void 0 : _d[0].sys.id); })) {
                            result.topics.push({
                                id: (_6 = (_5 = (_4 = (_3 = topic.fields) === null || _3 === void 0 ? void 0 : _3.parent) === null || _4 === void 0 ? void 0 : _4[0].fields) === null || _5 === void 0 ? void 0 : _5.parent) === null || _6 === void 0 ? void 0 : _6[0].sys.id,
                                name: (_10 = (_9 = (_8 = (_7 = topic.fields) === null || _7 === void 0 ? void 0 : _7.parent) === null || _8 === void 0 ? void 0 : _8[0].fields) === null || _9 === void 0 ? void 0 : _9.parent) === null || _10 === void 0 ? void 0 : _10[0].fields.name,
                                slug: (_14 = (_13 = (_12 = (_11 = topic.fields) === null || _11 === void 0 ? void 0 : _11.parent) === null || _12 === void 0 ? void 0 : _12[0].fields) === null || _13 === void 0 ? void 0 : _13.parent) === null || _14 === void 0 ? void 0 : _14[0].fields.slug,
                            });
                        }
                        if (!result.subtopics.some(e => { var _a, _b; return e.id === ((_b = (_a = topic.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.subtopics.push({
                                id: (_16 = (_15 = topic.fields) === null || _15 === void 0 ? void 0 : _15.parent) === null || _16 === void 0 ? void 0 : _16[0].sys.id,
                                topicId: (_20 = (_19 = (_18 = (_17 = topic.fields) === null || _17 === void 0 ? void 0 : _17.parent) === null || _18 === void 0 ? void 0 : _18[0].fields) === null || _19 === void 0 ? void 0 : _19.parent) === null || _20 === void 0 ? void 0 : _20[0].sys.id,
                                topicSlug: (_24 = (_23 = (_22 = (_21 = topic.fields) === null || _21 === void 0 ? void 0 : _21.parent) === null || _22 === void 0 ? void 0 : _22[0].fields) === null || _23 === void 0 ? void 0 : _23.parent) === null || _24 === void 0 ? void 0 : _24[0].fields.slug,
                                name: (_26 = (_25 = topic.fields) === null || _25 === void 0 ? void 0 : _25.parent) === null || _26 === void 0 ? void 0 : _26[0].fields.name,
                                slug: (_28 = (_27 = topic.fields) === null || _27 === void 0 ? void 0 : _27.parent) === null || _28 === void 0 ? void 0 : _28[0].fields.slug,
                            });
                        }
                    }
                    return result;
                }, { topics: [], subtopics: [] })
                : { topics: [], subtopics: [] };
            resultObj.topics = resultObj.topics.sort((a, b) => a.name.localeCompare(b.name));
            resultObj.subtopics = resultObj.subtopics.sort((a, b) => a.name.localeCompare(b.name));
            return resultObj;
        }
        catch (e) {
            console.error(`Content Topics/Subtopics parsing error, ${e.message}`);
            return { topics: [], subtopics: [] };
        }
    }
    static parseContentIndustries(industries) {
        try {
            const resultObj = Array.isArray(industries)
                ? industries.reduce((result, industry) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    if (!industry.fields) {
                        return result;
                    }
                    if (industry.fields.level === Helpers.TAXONOMY_LEVELS[1]) {
                        if (!result.industries.some(a => a.id === industry.sys.id)) {
                            result.industries.push({
                                id: industry.sys.id,
                                name: industry.fields.name,
                                slug: industry.fields.slug,
                            });
                        }
                    }
                    if (((_a = industry.fields) === null || _a === void 0 ? void 0 : _a.parent) && ((_c = (_b = industry.fields) === null || _b === void 0 ? void 0 : _b.parent) === null || _c === void 0 ? void 0 : _c[0]) && ((_e = (_d = industry.fields) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e[0].fields) &&
                        industry.fields.level === Helpers.TAXONOMY_LEVELS[2]) {
                        if (!result.industries.some(b => { var _a, _b; return b.id === ((_b = (_a = industry.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.industries.push({
                                id: (_g = (_f = industry.fields) === null || _f === void 0 ? void 0 : _f.parent) === null || _g === void 0 ? void 0 : _g[0].sys.id,
                                name: (_j = (_h = industry.fields) === null || _h === void 0 ? void 0 : _h.parent) === null || _j === void 0 ? void 0 : _j[0].fields.name,
                                slug: (_l = (_k = industry.fields) === null || _k === void 0 ? void 0 : _k.parent) === null || _l === void 0 ? void 0 : _l[0].fields.slug,
                            });
                        }
                    }
                    return result;
                }, { industries: [] })
                : { industries: [] };
            resultObj.industries = resultObj.industries.sort((a, b) => a.name.localeCompare(b.name));
            return resultObj.industries;
        }
        catch (e) {
            console.error(`Content Industries / Trends parsing error, ${e.message}`);
            return { industries: [] };
        }
    }
    static parseContentSkills(skills) {
        try {
            const resultObj = Array.isArray(skills)
                ? skills.reduce((result, skill) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                    if (!skill.fields) {
                        return result;
                    }
                    if (skill.fields.level === Helpers.TAXONOMY_LEVELS[1]) {
                        if (!result.skills.some(a => a.id === skill.sys.id)) {
                            result.skills.push({
                                id: skill.sys.id,
                                name: skill.fields.name,
                                slug: skill.fields.slug,
                            });
                        }
                    }
                    if (((_a = skill.fields) === null || _a === void 0 ? void 0 : _a.parent) && ((_c = (_b = skill.fields) === null || _b === void 0 ? void 0 : _b.parent) === null || _c === void 0 ? void 0 : _c[0]) && ((_e = (_d = skill.fields) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e[0].fields) &&
                        skill.fields.level === Helpers.TAXONOMY_LEVELS[2]) {
                        if (!result.skills.some(b => { var _a, _b; return b.id === ((_b = (_a = skill.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.skills.push({
                                id: (_g = (_f = skill.fields) === null || _f === void 0 ? void 0 : _f.parent) === null || _g === void 0 ? void 0 : _g[0].sys.id,
                                name: (_j = (_h = skill.fields) === null || _h === void 0 ? void 0 : _h.parent) === null || _j === void 0 ? void 0 : _j[0].fields.name,
                                slug: (_l = (_k = skill.fields) === null || _k === void 0 ? void 0 : _k.parent) === null || _l === void 0 ? void 0 : _l[0].fields.slug,
                            });
                        }
                        if (!result.subskills.some(c => c.id === skill.sys.id)) {
                            result.subskills.push({
                                id: skill.sys.id,
                                skillId: (_o = (_m = skill.fields) === null || _m === void 0 ? void 0 : _m.parent) === null || _o === void 0 ? void 0 : _o[0].sys.id,
                                skillSlug: (_q = (_p = skill.fields) === null || _p === void 0 ? void 0 : _p.parent) === null || _q === void 0 ? void 0 : _q[0].fields.slug,
                                name: skill.fields.name,
                                slug: skill.fields.slug,
                            });
                        }
                    }
                    return result;
                }, { skills: [], subskills: [] })
                : { skills: [], subskills: [] };
            resultObj.skills = resultObj.skills.sort((a, b) => a.name.localeCompare(b.name));
            resultObj.subskills = resultObj.subskills.sort((a, b) => a.name.localeCompare(b.name));
            return resultObj;
        }
        catch (e) {
            console.error(`Content skills/subkills parsing error, ${e.message}`);
            return { skills: [], subskills: [] };
        }
    }
    static parseContentLocations(locations) {
        try {
            const resultObj = Array.isArray(locations)
                ? locations.reduce((result, location) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35;
                    if (!location.fields) {
                        return result;
                    }
                    if (location.fields.level === Helpers.TAXONOMY_LEVELS[1]) {
                        if (!result.locations.some(a => a.id === location.sys.id)) {
                            result.locations.push({
                                id: location.sys.id,
                                name: location.fields.name,
                                slug: location.fields.slug,
                            });
                        }
                    }
                    if (((_a = location.fields) === null || _a === void 0 ? void 0 : _a.parent) && ((_c = (_b = location.fields) === null || _b === void 0 ? void 0 : _b.parent) === null || _c === void 0 ? void 0 : _c[0]) && ((_e = (_d = location.fields) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e[0].fields) &&
                        location.fields.level === Helpers.TAXONOMY_LEVELS[2]) {
                        if (!result.locations.some(b => { var _a, _b; return b.id === ((_b = (_a = location.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.locations.push({
                                id: (_g = (_f = location.fields) === null || _f === void 0 ? void 0 : _f.parent) === null || _g === void 0 ? void 0 : _g[0].sys.id,
                                name: (_j = (_h = location.fields) === null || _h === void 0 ? void 0 : _h.parent) === null || _j === void 0 ? void 0 : _j[0].fields.name,
                                slug: (_l = (_k = location.fields) === null || _k === void 0 ? void 0 : _k.parent) === null || _l === void 0 ? void 0 : _l[0].fields.slug,
                            });
                        }
                        if (!result.countries.some(c => c.id === location.sys.id)) {
                            result.countries.push({
                                id: location.sys.id,
                                locationId: (_o = (_m = location.fields) === null || _m === void 0 ? void 0 : _m.parent) === null || _o === void 0 ? void 0 : _o[0].sys.id,
                                locationSlug: (_q = (_p = location.fields) === null || _p === void 0 ? void 0 : _p.parent) === null || _q === void 0 ? void 0 : _q[0].fields.slug,
                                name: location.fields.name,
                                slug: location.fields.slug,
                            });
                        }
                    }
                    if (((_t = (_s = (_r = location.fields) === null || _r === void 0 ? void 0 : _r.parent) === null || _s === void 0 ? void 0 : _s[0].fields) === null || _t === void 0 ? void 0 : _t.parent) && ((_x = (_w = (_v = (_u = location.fields) === null || _u === void 0 ? void 0 : _u.parent) === null || _v === void 0 ? void 0 : _v[0].fields) === null || _w === void 0 ? void 0 : _w.parent) === null || _x === void 0 ? void 0 : _x[0]) && ((_1 = (_0 = (_z = (_y = location.fields) === null || _y === void 0 ? void 0 : _y.parent) === null || _z === void 0 ? void 0 : _z[0].fields) === null || _0 === void 0 ? void 0 : _0.parent) === null || _1 === void 0 ? void 0 : _1[0].fields) &&
                        location.fields.level === Helpers.TAXONOMY_LEVELS[3]) {
                        if (!result.locations.some(b => { var _a, _b, _c, _d; return b.id === ((_d = (_c = (_b = (_a = location.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].fields) === null || _c === void 0 ? void 0 : _c.parent) === null || _d === void 0 ? void 0 : _d[0].sys.id); })) {
                            result.locations.push({
                                id: (_5 = (_4 = (_3 = (_2 = location.fields) === null || _2 === void 0 ? void 0 : _2.parent) === null || _3 === void 0 ? void 0 : _3[0].fields) === null || _4 === void 0 ? void 0 : _4.parent) === null || _5 === void 0 ? void 0 : _5[0].sys.id,
                                name: (_9 = (_8 = (_7 = (_6 = location.fields) === null || _6 === void 0 ? void 0 : _6.parent) === null || _7 === void 0 ? void 0 : _7[0].fields) === null || _8 === void 0 ? void 0 : _8.parent) === null || _9 === void 0 ? void 0 : _9[0].fields.name,
                                slug: (_13 = (_12 = (_11 = (_10 = location.fields) === null || _10 === void 0 ? void 0 : _10.parent) === null || _11 === void 0 ? void 0 : _11[0].fields) === null || _12 === void 0 ? void 0 : _12.parent) === null || _13 === void 0 ? void 0 : _13[0].fields.slug,
                            });
                        }
                        if (!result.countries.some(b => { var _a, _b; return b.id === ((_b = (_a = location.fields) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b[0].sys.id); })) {
                            result.countries.push({
                                id: (_15 = (_14 = location.fields) === null || _14 === void 0 ? void 0 : _14.parent) === null || _15 === void 0 ? void 0 : _15[0].sys.id,
                                locationId: (_19 = (_18 = (_17 = (_16 = location.fields) === null || _16 === void 0 ? void 0 : _16.parent) === null || _17 === void 0 ? void 0 : _17[0].fields) === null || _18 === void 0 ? void 0 : _18.parent) === null || _19 === void 0 ? void 0 : _19[0].sys.id,
                                locationSlug: (_23 = (_22 = (_21 = (_20 = location.fields) === null || _20 === void 0 ? void 0 : _20.parent) === null || _21 === void 0 ? void 0 : _21[0].fields) === null || _22 === void 0 ? void 0 : _22.parent) === null || _23 === void 0 ? void 0 : _23[0].fields.slug,
                                name: (_25 = (_24 = location.fields) === null || _24 === void 0 ? void 0 : _24.parent) === null || _25 === void 0 ? void 0 : _25[0].fields.name,
                                slug: (_27 = (_26 = location.fields) === null || _26 === void 0 ? void 0 : _26.parent) === null || _27 === void 0 ? void 0 : _27[0].fields.slug,
                            });
                        }
                        if (!result.states.some(c => c.id === location.sys.id)) {
                            result.states.push({
                                id: location.sys.id,
                                locationId: (_31 = (_30 = (_29 = (_28 = location.fields) === null || _28 === void 0 ? void 0 : _28.parent) === null || _29 === void 0 ? void 0 : _29[0].fields) === null || _30 === void 0 ? void 0 : _30.parent) === null || _31 === void 0 ? void 0 : _31[0].sys.id,
                                locationSlug: (_35 = (_34 = (_33 = (_32 = location.fields) === null || _32 === void 0 ? void 0 : _32.parent) === null || _33 === void 0 ? void 0 : _33[0].fields) === null || _34 === void 0 ? void 0 : _34.parent) === null || _35 === void 0 ? void 0 : _35[0].fields.slug,
                                name: location.fields.name,
                                slug: location.fields.slug,
                            });
                        }
                    }
                    return result;
                }, { locations: [], countries: [], states: [] })
                : { locations: [], countries: [], states: [] };
            resultObj.locations = resultObj.locations.sort((a, b) => a.name.localeCompare(b.name));
            resultObj.countries = resultObj.countries.sort((a, b) => a.name.localeCompare(b.name));
            resultObj.states = resultObj.states.sort((a, b) => a.name.localeCompare(b.name));
            return resultObj;
        }
        catch (e) {
            console.error(`Content locations / countries / states parsing error, ${e.message}`);
            return { locations: [], countries: [], states: [] };
        }
    }
    static parseTable(data) {
        return RichTextBlocks_1.default.createTable(data);
    }
    static getImage(image) {
        if (!image || !image.fields || !image.fields.image || !image.fields.image.fields)
            return null;
        try {
            return {
                altText: image.fields.altText,
                caption: image.fields.caption,
                credit: image.fields.credit,
                title: image.fields.title,
                url: image.fields.image.fields.file.url,
            };
        }
        catch (e) {
            console.error('Image parsing error', e.message);
            return null;
        }
    }
    static parseDownloads(downloads, isLocked = false) {
        try {
            if (!Array.isArray(downloads)) {
                const { contentType, name, fileNames, buttonText } = downloads;
                return {
                    contentType,
                    name,
                    fileNames,
                    buttonText,
                    fileLink: (!isLocked && downloads.documents[0] && downloads.documents[0].fields.file.url) || '',
                    fileSize: downloads.documents[0] && formatBytes(downloads.documents[0].fields.file.details.size),
                };
            }
            return downloads.map((item) => ({
                name: item.fields.name,
                fileNames: item.fields.fileNames,
                buttonText: item.fields.buttonText,
                fileLink: (!isLocked && item.fields.documents[0] && item.fields.documents[0].fields.file.url) || '',
                fileSize: item.fields.documents[0] && formatBytes(item.fields.documents[0].fields.file.details.size),
            }));
        }
        catch (e) {
            return [];
        }
    }
    static accessRestrictionSlugToEnum(access) {
        if (!access || !access.fields || !access.fields.slug) {
            return [];
        }
        switch (access.fields.slug) {
            case 'aicpa-members':
                return [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001];
            case 'cima-member':
                return [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001];
            case 'logged-in':
                return [mxp_schemas_1.User.MembershipIdsEnum.LOGGED_IN];
            default:
                return [];
        }
    }
    static parsedCredentialSlugToEnum(credential) {
        if (!credential || !credential.fields || !credential.fields.slug) {
            return [];
        }
        switch (credential.fields.oktaRoleId) {
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022:
                return [credential.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023];
            default:
                return [credential.fields.oktaRoleId];
        }
    }
    static parsedMembershipSlugToEnum(membership) {
        if (!membership || !membership.fields || !membership.fields.slug || !membership.fields.oktaRoleId) {
            return [];
        }
        switch (membership.fields.oktaRoleId) {
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006:
                return [membership.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008:
                return [membership.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010:
                return [membership.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012:
                return [membership.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031:
                return [membership.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032];
            default:
                return [membership.fields.oktaRoleId];
        }
    }
    static parseTopicalSubscriptionToEnum(topicalSubscription) {
        if (!topicalSubscription || !topicalSubscription.fields || !topicalSubscription.fields.slug) {
            return [];
        }
        return [topicalSubscription.fields.oktaRoleId];
    }
    static parseSectionSlugToEnum(section) {
        if (!section || !section.fields || !section.fields.slug) {
            return [];
        }
        switch (section.fields.oktaRoleId) {
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033:
                return [section.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004:
                return [section.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018:
                return [section.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019];
            case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002:
                return [section.fields.oktaRoleId, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003];
            default:
                return [section.fields.oktaRoleId];
        }
    }
    static extractContentRoles(access, credentials, memberships, sections, topicalSubscriptions) {
        // based on https://cgmastore.atlassian.net/wiki/spaces/NEX/pages/1043694010/Content+Enablers#Data-setup-and-mapping
        if (!access && !credentials && !memberships && !sections && !topicalSubscriptions) {
            // this is public content ==> set roles value to null
            return { contentRoles: null, restrictionDetails: null };
        }
        const roles = [
            ...(Array.isArray(access) ? access : [access]),
            ...(Array.isArray(credentials) ? credentials : [credentials]),
            ...(Array.isArray(memberships) ? memberships : [memberships]),
            ...(Array.isArray(sections) ? sections : [sections]),
            ...(Array.isArray(topicalSubscriptions) ? topicalSubscriptions : [topicalSubscriptions]),
        ];
        const restrictionDetails = roles
            .reduce((acc, role) => {
            if (!role || !role.sys || !role.sys.contentType || !role.sys.contentType.sys) {
                return acc;
            }
            const type = role.sys.contentType.sys.id;
            switch (type) {
                case 'accessRestriction':
                    const accessRestrictionArr = Helpers.accessRestrictionSlugToEnum(role);
                    const accessRestrictionDetails = accessRestrictionArr.map((accessRestriction) => {
                        var _a;
                        return ({
                            role: accessRestriction,
                            membershipType: user_1.membershipMapNames[accessRestriction],
                            learnMoreUrl: (_a = role === null || role === void 0 ? void 0 : role.fields) === null || _a === void 0 ? void 0 : _a.learnMoreUrl,
                        });
                    });
                    return [...acc, ...accessRestrictionDetails];
                case 'credential':
                    const credentialArr = Helpers.parsedCredentialSlugToEnum(role);
                    const credentialRestrictionDetails = credentialArr.map((credential) => {
                        var _a;
                        return ({
                            role: credential,
                            membershipType: user_1.membershipMapNames[credential],
                            learnMoreUrl: (_a = role === null || role === void 0 ? void 0 : role.fields) === null || _a === void 0 ? void 0 : _a.learnMoreLink,
                        });
                    });
                    return [...acc, ...credentialRestrictionDetails];
                case 'firmMembership':
                    const firmMembershipArr = Helpers.parsedMembershipSlugToEnum(role);
                    const firmMembershipRestrictionDetails = firmMembershipArr.map((firmMembership) => {
                        var _a;
                        return ({
                            role: firmMembership,
                            membershipType: user_1.membershipMapNames[firmMembership],
                            learnMoreUrl: (_a = role === null || role === void 0 ? void 0 : role.fields) === null || _a === void 0 ? void 0 : _a.learnMoreLink,
                        });
                    });
                    return [...acc, ...firmMembershipRestrictionDetails];
                case 'section':
                    const sectionArr = Helpers.parseSectionSlugToEnum(role);
                    const sectionRestrictionDetails = sectionArr.map((section) => {
                        var _a;
                        return ({
                            role: section,
                            membershipType: user_1.membershipMapNames[section],
                            learnMoreUrl: (_a = role === null || role === void 0 ? void 0 : role.fields) === null || _a === void 0 ? void 0 : _a.learnMoreLink,
                        });
                    });
                    return [...acc, ...sectionRestrictionDetails];
                case 'topicalSubscription':
                    const topicalSubscriptionArr = Helpers.parseSectionSlugToEnum(role);
                    const topicalSubscriptionRestrictionDetails = topicalSubscriptionArr.map((topicalSubscription) => ({
                        role: topicalSubscription,
                        membershipType: user_1.membershipMapNames[topicalSubscription],
                    }));
                    return [...acc, ...topicalSubscriptionRestrictionDetails];
                default:
                    return acc;
            }
        }, [])
            .filter((item, i, arr) => arr.indexOf(item) === i);
        const contentRoles = restrictionDetails.map((restriction) => restriction.role);
        return { contentRoles: contentRoles || null, restrictionDetails: restrictionDetails || null };
    }
    static isContentLocked(userRoles, contentRoles) {
        if (!contentRoles) {
            // public content
            return false;
        }
        if (Array.isArray(contentRoles) && contentRoles.length === 0 && Array.isArray(userRoles)) {
            // logged in content
            return false;
        }
        // content locked by some role, check if user has it
        return !(userRoles || []).some((userRole) => {
            return contentRoles.includes(userRole);
        });
    }
    static getMatchedRoles(userRoles, contentRoles) {
        return userRoles && contentRoles && Array.isArray(userRoles)
            ? contentRoles.filter((role) => userRoles.indexOf(role) > -1)
            : [];
    }
    static getContentLockStatus(contentRoles, isLocked) {
        // LOCKED: if users roles has one matching item in content roles,
        // UNLOCKED: if users roles doesn't match with any of contents role,
        // NO_LOCK: content doesn't have roles any roles assigned to it
        return !contentRoles || !contentRoles.length
            ? mxp_schemas_1.Content.ContentLockStatus.NO_LOCK
            : isLocked
                ? mxp_schemas_1.Content.ContentLockStatus.LOCKED
                : mxp_schemas_1.Content.ContentLockStatus.UNLOCKED;
    }
    static getContentVideo(videoItem, isLocked) {
        return !isLocked && (videoItem === null || videoItem === void 0 ? void 0 : videoItem.fields)
            ? videoItem.fields.embedCode
                ? { embedCode: videoItem.fields.embedCode }
                : videoItem.fields.id
                    ? { brightcove: Object.assign({}, videoItem.fields) }
                    : null
            : (videoItem === null || videoItem === void 0 ? void 0 : videoItem.id) ? { brightcove: Object.assign({}, videoItem) }
                : null;
    }
    static getContentDownloads(documents) {
        return ((documents === null || documents === void 0 ? void 0 : documents.map((document) => {
            var _a, _b, _c, _d, _e, _f;
            return {
                name: ((_a = document === null || document === void 0 ? void 0 : document.fields) === null || _a === void 0 ? void 0 : _a.title) || '',
                fileLink: ((_c = (_b = document === null || document === void 0 ? void 0 : document.fields) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.url) || '',
                fileNames: [],
                buttonText: '',
                fileSize: ((_f = (_e = (_d = document === null || document === void 0 ? void 0 : document.fields) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.details) === null || _f === void 0 ? void 0 : _f.size) || '',
            };
        })) || []);
    }
    static getLinks(data) {
        const links = [];
        for (const property in data) {
            if (data.hasOwnProperty(property) && property.toString().startsWith('link')) {
                const generatedLink = Helpers.generateEntryLinks(data[property], false, true);
                links.push(Object.assign(Object.assign({ linkId: property }, data[property]), { generatedLink }));
            }
        }
        return links;
    }
    static generateEntryLinks(node, isLocked, isAdvTable = false, isAccessNow) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const contentType = (!isAdvTable ? node.data.target.sys.contentType.sys.id : (_c = (_b = (_a = node === null || node === void 0 ? void 0 : node.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id) || '';
        if (!contentType)
            return;
        if (contentType === Helpers.CONTENT_TYPES.ARTICLE) {
            return RichTextBlocks_1.default.createGenericContentLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.ARTICLE_EXTERNAL) {
            return RichTextBlocks_1.default.createExternalArticleLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.DOWNLOAD_TEMPLATE) {
            return RichTextBlocks_1.default.createGenericContentLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.PODCAST) {
            return RichTextBlocks_1.default.createGenericContentLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.VIDEO) {
            return RichTextBlocks_1.default.createGenericContentLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.STATIC_ARTICLE) {
            return RichTextBlocks_1.default.createStaticArticleLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.TOPIC) {
            return RichTextBlocks_1.default.createTopicAggregationLink(node, isLocked, isAdvTable, isAccessNow);
        }
        if (contentType === Helpers.CONTENT_TYPES.TOOLKIT_PAGE_TEMPLATE) {
            return RichTextBlocks_1.default.createGenericContentLink(node, isLocked, isAdvTable);
        }
        if (contentType === Helpers.CONTENT_TYPES.LANDING_PAGE_TEMPLATE) {
            return RichTextBlocks_1.default.createCampaignLink(node);
        }
        if (contentType === Helpers.CONTENT_TYPES.LINK || contentType === Helpers.CONTENT_TYPES.LINK_INTERNAL) {
            return node.fields.url;
        }
        if (contentType === Helpers.CONTENT_TYPES.STATIC_LANDING_PAGE) {
            return `/${(_d = node.fields) === null || _d === void 0 ? void 0 : _d.contentCategory.fields.slug}/landing/${(_e = node.fields) === null || _e === void 0 ? void 0 : _e.slug}`;
        }
        if (contentType === Helpers.CONTENT_TYPES.PRODUCT_AGGREGATION_PAGE) {
            return `/${mxp_schemas_1.Content.CategorySlugs.CPE_LEARNING}/${(_h = (_g = (_f = node.fields) === null || _f === void 0 ? void 0 : _f.mainSectionTopics[0]) === null || _g === void 0 ? void 0 : _g.fields) === null || _h === void 0 ? void 0 : _h.slug}`;
        }
    }
    static parseJSON(text) {
        try {
            return JSON.parse(text);
        }
        catch (_a) {
            return {};
        }
    }
    static isCimaMipContentType(contentType) {
        return this.CONTENT_TYPES.CIMA_MIP === contentType;
    }
    static isCenterMembershipContentType(contentType) {
        return this.CONTENT_TYPES.CENTER_MEMBERSHIP === contentType;
    }
}
Helpers.TAXONOMY_LEVELS = ['level0', 'level1', 'level2', 'level3'];
Helpers.BLOCK_TYPES = {
    TRENDING_CONTENT_BLOCK: 'trendingContentBlock',
    BENEFITS_BLOCK: 'benefitsBlock',
    INTEGRATED_SEARCH_BLOCK: 'integratedSearchBlock',
    TOPIC_LIST_BLOCK: 'topicListBlock',
    PRODUCT_TYPE_LIST_BLOCK: 'productTypeListBlock',
    LONG_FORM_BLOCK: 'longFormBlock',
    VIDEO_BLOCK: 'videoBlock',
    INQUIRY_FORM_BLOCK: 'inquiryFormBlock',
    ACCORDION_BLOCK: 'accordionBlock',
    TABLE_BLOCK: 'tableBlock',
    RECOMMENDED_PRODUCTS_BLOCK: 'recommendationBlock',
    PROMOTIONAL_COMPONENT_BLOCK: 'promotionalComponent',
    LIST_BLOCK: 'blockList',
    GROUP_MEMBERS_BLOCK: 'groupMemberBlock',
    MEMBERSHIP_PRODUCT_BLOCK: 'membershipProductsBlock',
    FEATURED_CONTENT_BLOCK: 'featuredContentBlock',
    TOOLKIT_PAGE_BLOCK: 'toolkitPageBlock',
    LANDING_PAGE_BLOCK: 'landingPageBlock',
    MARKETING_BLOCK: 'marketingBlock',
    WELCOME_BLOCK: 'welcomeBlock',
    LAST_FOUR_MODIFIED_PRODUCTS_BLOCK: 'lastFourModifiedProductsBlock',
    PRODUCT_MARKETING_PROMOTIONS_BLOCK: 'contentAndProductPromotionBlock',
    STEPPER_BLOCK: 'blockSteps',
    TESTIMONIALS_BLOCK: 'blockTestimonials',
    CEROS_ANIMATION_BLOCK: 'cerosAnimationBlock',
    TURTL_ANIMATION_BLOCK: 'turtlAnimationBlock',
    BLUETOAD_PAGETURNER_BLOCK: 'blueToadPageTurnerBlock',
    SYLLABUS_BLOCK: 'syllabusBlock',
    PROMOCARD_BLOCK: 'promoCards',
    QUICKLINKS_BLOCK: 'quickLinksBlock',
    STATS_BLOCK: 'blockStats',
    WELCOME_BLOCK_CAROUSEL: 'welcomeBlockCarousel',
    EDITORIAL_HERO_BLOCK: 'editorialHeroBlock',
};
Helpers.CONTENT_TYPES = Object.assign({ FCMA: 'fcma', IMAGE: 'image', PULL_QUOTE: 'pullQuote', TABLE: 'table', ARTICLE: 'article', ARTICLE_EXTERNAL: 'articleExternal', PODCAST: 'podcast', VIDEO: 'video', DOWNLOAD: 'download', PRODUCT_REFERENCE: 'product', DOWNLOAD_TEMPLATE: 'downloadTemplate', STATIC_ARTICLE: 'staticArticle', TOPIC: 'topic', BRIGHTCOVE: 'brightcoveVideo', LINK: 'link', LISTS: 'lists', STATIC_LANDING_PAGE: 'staticLandingPage', ADVANCE_TABLE: 'advancedTable', TOOLKIT_PAGE_TEMPLATE: 'toolkitPageTemplate', LANDING_PAGE_TEMPLATE: 'landingPage', LINK_INTERNAL: 'linkInternal', PRODUCT_AGGREGATION_PAGE: 'productAggregationPage', DYNAMIC_LIST: 'dynamicList', LANDING_PAGE_SUB_BLOCK: 'landingPageSubBlock', CIMA_MIP: 'cimaMip', CENTER_MEMBERSHIP: 'centerMembership', ENTRY_LEVEL: 'entryLevel', PRODUCT_DISCOUNT: 'productDiscount', RAW_RICH_TEXT: 'rawRichText', CONSTANT: 'constant', PICK_LIST: 'pickList' }, Helpers.BLOCK_TYPES);
Helpers.LANDING_BLOCKS_STYLES = {
    MARKETING: 'Marketing',
    WELCOME: 'Welcome',
    LAST_FOUR_MODIFIED_PRODUCTS: 'Last Four Modified Products',
    PRODUCT_MARKETING_PROMOTIONS: 'Content and Product Promotion',
    TRENDING_CONTENT: 'Trending Content',
    BENEFITS: 'Benefits',
    INTEGRATED_SEARCH: 'Integrated Search',
    TOPIC_LIST: 'Topic List',
    PRODUCT_TYPE_LIST: 'ProductType List',
    LONG_FORM: 'Long Form',
    VIDEO: 'Video',
    INQUIRY_FORM: 'Inquiry Form',
    ACCORDION: 'Accordion',
    TABLE: 'Table',
    LIST: 'List',
    RECOMMENDED_PRODUCTS: 'Recommended CPE & Learning',
    TOOLKIT: 'Toolkit',
    GROUP_MEMBERS: 'Group Members',
    CEROS_ANIMATION: 'Ceros Animation',
    TURTL_ANIMATION: 'Turtl Animation',
    BLUETOAD_PAGETURNER: 'Bluetoad Page Turner',
    PROMOCARD: 'Promo',
    QUICKLINKS: 'Quicklinks',
    STATSBLOCK: 'Stats',
    WELCOME_BANNER: 'Welcome Banner',
    EDITORIAL: 'Editorial',
};
Helpers.BLOCK_TYPE_STYLE_MAP = {
    [Helpers.CONTENT_TYPES.MARKETING_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.MARKETING,
    [Helpers.CONTENT_TYPES.WELCOME_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.WELCOME,
    [Helpers.CONTENT_TYPES.LAST_FOUR_MODIFIED_PRODUCTS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.LAST_FOUR_MODIFIED_PRODUCTS,
    [Helpers.CONTENT_TYPES.PRODUCT_MARKETING_PROMOTIONS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.PRODUCT_MARKETING_PROMOTIONS,
    [Helpers.CONTENT_TYPES.TRENDING_CONTENT_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.TRENDING_CONTENT,
    [Helpers.CONTENT_TYPES.BENEFITS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.BENEFITS,
    [Helpers.CONTENT_TYPES.INTEGRATED_SEARCH_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.INTEGRATED_SEARCH,
    [Helpers.CONTENT_TYPES.TOPIC_LIST_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.TOPIC_LIST,
    [Helpers.CONTENT_TYPES.PRODUCT_TYPE_LIST_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.PRODUCT_TYPE_LIST,
    [Helpers.CONTENT_TYPES.LONG_FORM_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.LONG_FORM,
    [Helpers.CONTENT_TYPES.VIDEO_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.VIDEO,
    [Helpers.CONTENT_TYPES.INQUIRY_FORM_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.INQUIRY_FORM,
    [Helpers.CONTENT_TYPES.ACCORDION_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.ACCORDION,
    [Helpers.CONTENT_TYPES.GROUP_MEMBERS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.GROUP_MEMBERS,
    [Helpers.CONTENT_TYPES.CEROS_ANIMATION_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.CEROS_ANIMATION,
    [Helpers.CONTENT_TYPES.TURTL_ANIMATION_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.TURTL_ANIMATION,
    [Helpers.CONTENT_TYPES.BLUETOAD_PAGETURNER_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.BLUETOAD_PAGETURNER,
    [Helpers.CONTENT_TYPES.TABLE_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.TABLE,
    [Helpers.CONTENT_TYPES.RECOMMENDED_PRODUCTS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.RECOMMENDED_PRODUCTS,
    [Helpers.CONTENT_TYPES.TOOLKIT_PAGE_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.TOOLKIT,
    [Helpers.CONTENT_TYPES.PROMOCARD_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.PROMOCARD,
    [Helpers.CONTENT_TYPES.QUICKLINKS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.QUICKLINKS,
    [Helpers.CONTENT_TYPES.STATS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.STATSBLOCK,
    [Helpers.CONTENT_TYPES.WELCOME_BLOCK_CAROUSEL]: Helpers.LANDING_BLOCKS_STYLES.WELCOME_BANNER,
    [Helpers.CONTENT_TYPES.EDITORIAL_HERO_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.EDITORIAL,
};
Helpers.BLOCK_STYLE_TYPE_MAP = {
    [Helpers.LANDING_BLOCKS_STYLES.MARKETING]: Helpers.CONTENT_TYPES.MARKETING_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.WELCOME]: Helpers.CONTENT_TYPES.WELCOME_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.LAST_FOUR_MODIFIED_PRODUCTS]: Helpers.CONTENT_TYPES.LAST_FOUR_MODIFIED_PRODUCTS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.PRODUCT_MARKETING_PROMOTIONS]: Helpers.CONTENT_TYPES.PRODUCT_MARKETING_PROMOTIONS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.TRENDING_CONTENT]: Helpers.CONTENT_TYPES.TRENDING_CONTENT_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.BENEFITS]: Helpers.CONTENT_TYPES.BENEFITS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.INTEGRATED_SEARCH]: Helpers.CONTENT_TYPES.INTEGRATED_SEARCH_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.TOPIC_LIST]: Helpers.CONTENT_TYPES.TOPIC_LIST_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.PRODUCT_TYPE_LIST]: Helpers.CONTENT_TYPES.PRODUCT_TYPE_LIST_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.LONG_FORM]: Helpers.CONTENT_TYPES.LONG_FORM_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.VIDEO]: Helpers.CONTENT_TYPES.VIDEO_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.INQUIRY_FORM]: Helpers.CONTENT_TYPES.INQUIRY_FORM_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.ACCORDION]: Helpers.CONTENT_TYPES.ACCORDION_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.GROUP_MEMBERS]: Helpers.CONTENT_TYPES.GROUP_MEMBERS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.CEROS_ANIMATION]: Helpers.CONTENT_TYPES.CEROS_ANIMATION_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.TURTL_ANIMATION]: Helpers.CONTENT_TYPES.TURTL_ANIMATION_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.BLUETOAD_PAGETURNER]: Helpers.CONTENT_TYPES.BLUETOAD_PAGETURNER_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.TABLE]: Helpers.CONTENT_TYPES.TABLE_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.RECOMMENDED_PRODUCTS]: Helpers.CONTENT_TYPES.RECOMMENDED_PRODUCTS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.TOOLKIT]: Helpers.CONTENT_TYPES.TOOLKIT_PAGE_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.PROMOCARD]: Helpers.CONTENT_TYPES.PROMOCARD_BLOCK,
    [Helpers.CONTENT_TYPES.QUICKLINKS_BLOCK]: Helpers.LANDING_BLOCKS_STYLES.QUICKLINKS,
    [Helpers.LANDING_BLOCKS_STYLES.STATSBLOCK]: Helpers.CONTENT_TYPES.STATS_BLOCK,
    [Helpers.LANDING_BLOCKS_STYLES.WELCOME_BANNER]: Helpers.CONTENT_TYPES.WELCOME_BLOCK_CAROUSEL,
    [Helpers.LANDING_BLOCKS_STYLES.EDITORIAL]: Helpers.CONTENT_TYPES.EDITORIAL_HERO_BLOCK,
};
Helpers.lambdaSyncRole = ['lambdaSync'];
Helpers.getLocalizedContentItemFields = (locale, contentItem) => {
    return Object.keys(contentItem.fields).reduce((acc, key) => {
        return Object.assign(Object.assign({}, acc), { [key]: contentItem.fields[key][locale] || contentItem.fields[key] });
    }, {});
};
Helpers.parseCPECredit = cpeCredit => {
    if (!cpeCredit) {
        return [];
    }
    if (cpeCredit === 'Unlimited') {
        // using 255, as cpeCredit is an IEEE 754 Single precision float number
        // it is a 32 bit number with 1 bit for sign, 8 bits for exponent (int value) and 23 bits are for float precision
        // 8bit number max value is 255, thus the max value that this number can hold.
        return [255];
    }
    const credits = cpeCredit.split('-');
    return credits.map((credit) => parseFloat(credit.trim()));
};
exports.default = Helpers;
//# sourceMappingURL=helpers.js.map